// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"0b6788e58d12884a8611","691":"f93304c6307c99f12fd8"}[chunkId] + ".js";
};